import {mapGetters, mapActions} from 'vuex';

export default {
	computed: {
		...mapGetters('loading', ['dataLoader'])
	},
	methods: {
		...mapActions('loading', ['toggleLoader'])
	}
}